import { useState } from 'react';

import { AxiosPrivate } from '../utils/axios';
import { ResponseException } from '../models';

export const useRemoveOrganizationUsers = () => {
  const [isFetching, setFetching] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  return {
    errors,
    isFetching,
    success,
    submit: async (organizationId: string, userIds: string[]) => {
      setSuccess(false);
      setFetching(true);
      try {
        const data = { userIds };
        await AxiosPrivate.delete(`/organizations/${organizationId}/users`, { data });
        setSuccess(true);
        setErrors([]);
        return null;
      } catch (e) {
        setSuccess(false);
        setErrors(new ResponseException(e).getErrorMessage());
      } finally {
        setFetching(false);
      }
    },
  };
};
